import api from "@/services/api"

export const unapproveDevice = async (): Promise<void> => {
  await api.post("/devices/unapprove-device")
}
